/**
 * SQL data types for Databricks SQL
 */

export const PRIMITIVE_TYPES = [
  'BINARY',
  'BOOLEAN',
  'BYTE',
  'DATE',
  'DECIMAL',
  'DOUBLE',
  'FLOAT',
  'INT',
  'INTEGER',
  'INTERVAL',
  'LONG',
  'NUMERIC',
  'REAL',
  'SHORT',
  'STRING',
  'TIMESTAMP',
  'TIMESTAMP_LTZ',
  'TIMESTAMP_NTZ',
  'TINYINT',
  'VOID',
];

export const COMPOSITE_TYPES = ['ARRAY', 'MAP', 'STRUCT'];

export const NUMERIC_TYPES = [
  'BYTE',
  'SHORT',
  'INT',
  'INTEGER',
  'LONG',
  'FLOAT',
  'DOUBLE',
  'DECIMAL',
  'NUMERIC',
  'REAL',
  'TINYINT',
];

export const STRING_TYPES = ['STRING', 'VARCHAR', 'CHAR'];

export const DATE_TIME_TYPES = [
  'DATE',
  'TIMESTAMP',
  'TIMESTAMP_LTZ',
  'TIMESTAMP_NTZ',
  'INTERVAL',
];

export const BOOLEAN_TYPES = ['BOOLEAN'];

export const BINARY_TYPES = ['BINARY'];

export const ALL_TYPES = [...PRIMITIVE_TYPES, ...COMPOSITE_TYPES];
